import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import { Input as AntInput } from 'antd';
import styled from 'styled-components';
var Input = styled(AntInput)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.ant-input {\n    &::-webkit-outer-spin-button,\n    &::-webkit-inner-spin-button {\n      -webkit-appearance: none;\n      margin: 0;\n    }\n    &[type=number] {\n      -moz-appearance: textfield;\n    }\n\n    &-affix-wrapper {\n      &:focus, &-focused {\n        box-shadow: none;\n        border-color: ", ";\n      }\n\n      .ant-input-suffix {\n        color: ", ";\n      }\n    }\n  }\n  & .ant-input-disabled {\n    & {\n      color: ", ";\n    }\n  }\n"])), function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.darkGrey;
}, function (props) {
  return props.isError && props.theme.colors.danger;
});
Input.Password = styled(AntInput.Password)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  &.ant-input, &.ant-input-affix-wrapper {\n    &:focus, &-focused {\n      box-shadow: none;\n      border-color: ", ";\n    }\n\n    .ant-input-suffix {\n      color: ", ";\n    }\n  }\n"])), function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.darkGrey;
});
Input.Search = styled(AntInput.Search)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  .ant-input-group .ant-input {\n      width:", ";\n   }\n  &.ant-input, &.ant-input-affix-wrapper {\n    &:focus, &-focused {\n      box-shadow: none;\n      border-color: ", ";\n    }\n\n    input {\n      background: transparent;\n    }\n\n    .ant-input-suffix {\n      color: ", ";\n    }\n  }\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.theme.colors.primary;
}, function (props) {
  return props.theme.colors.darkGrey;
});
export default Input;